
  import * as ipxStaticRuntime$_4eLdBt4u0QM6D6n_eIvPm84eRnRSb0VF35G7LEeuXRI from 'D:/laragon/www/langitinspirasi_l12_nuxt3/halaman-admin/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "png",
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['ipxStatic']: { provider: ipxStaticRuntime$_4eLdBt4u0QM6D6n_eIvPm84eRnRSb0VF35G7LEeuXRI, defaults: {} }
    }
  }
